import { useLocation, useNavigate } from "react-router-dom";
import { scrollToSection } from "./Reveal";
import { usePrefix, useT } from "@/i18n";

export const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const t = useT().footer;
  const prefix = usePrefix();
  const homePath = prefix || "/";

  const goContact = () => {
    if (pathname !== homePath) {
      navigate(homePath, { state: { scrollTo: "#contact" } });
    } else {
      scrollToSection("#contact");
    }
  };

  return (
    <footer className="border-t border-bone/10 bg-ink text-bone" data-testid="site-footer">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-10 px-6 py-16 lg:flex-row lg:items-end lg:justify-between lg:px-12">
        <div>
          <div className="flex items-center gap-4">
            <img src="/images/logo-mark-light.png" alt="Monferrato Way" className="h-14 w-auto" />
            <div className="flex flex-col gap-1.5">
              <span className="text-lg font-semibold uppercase tracking-[0.22em] text-bone">Monferrato Way</span>
              <span className="text-xs uppercase tracking-[0.172em] text-bone/50">Discover a different Italy</span>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-bone/50">
            {t.tagline}
          </p>
        </div>
        <div className="flex flex-col gap-4 text-sm text-bone/50 lg:items-end">
          <a
            href="https://www.studioprojectworks.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-studio-link"
            className="group flex items-center gap-4 transition-colors duration-300 hover:text-terra lg:flex-row-reverse lg:text-right"
          >
            <span className="rounded-lg bg-bone px-3 py-2 transition-transform duration-300 group-hover:-translate-y-0.5">
              <img
                src="/images/studio-project-works.png"
                alt="Studio Project Works — Studio Tecnico Associato"
                className="h-9 w-auto"
              />
            </span>
          </a>
          <button
            data-testid="footer-contact-link"
            onClick={goContact}
            className="text-left transition-colors duration-300 hover:text-terra lg:text-right"
          >
            {t.contactLink}
          </button>
          <div className="flex gap-6 text-xs text-bone/40">
            <a
              href="https://www.iubenda.com/privacy-policy/65343853"
              className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed transition-colors duration-300 hover:text-terra"
              title="Privacy Policy"
              data-testid="footer-privacy-link"
            >
              {t.privacy}
            </a>
            <a
              href="https://www.iubenda.com/privacy-policy/65343853/cookie-policy"
              className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed transition-colors duration-300 hover:text-terra"
              title="Cookie Policy"
              data-testid="footer-cookies-link"
            >
              {t.cookies}
            </a>
          </div>
          <p className="text-xs text-bone/30">© 2026 Project Works Studio Tecnico Associato · Tutti i diritti riservati</p>
        </div>
      </div>
    </footer>
  );
};
